export default {
  title: 'Plătește cu PayPal',
  error: 'Plata prin PayPal nu a putut fi finalizată. Încearcă din nou.',
};
